import { JSX } from "react";

import { cn } from "@/utils/cn.ts";

interface TvCardSkeletonProps {
  className?: string;
}

const DistributorSkeleton = ({ className }: TvCardSkeletonProps): JSX.Element => {
  return (
    <div className={cn("group/card animate-pulse", className)}>
      <div className={"relative"}>
        <div
          className={
            "bg-surface-bright aspect-[560/160] h-auto w-full rounded-3xl max-lg:rounded-2xl max-md:max-h-[100px]"
          }
        />
      </div>
    </div>
  );
};

export default DistributorSkeleton;
